import { archiveItems } from '../data';
import InformationSection from './information-section';

const ExistingDataSection = () => (
  <InformationSection
    title="Your existing data"
    description="Moving to Somatiq PACS does not mean moving your archive."
    items={archiveItems}
  />
);

export default ExistingDataSection;
